/**
 * Logger centralizzato di cdp_fe_istanze.
 *
 * - `debug()`: emesso SOLO se il debug è abilitato — controllato a runtime da
 *   `window.FE_COMMONS_CONFIG.debug` (impostato in main.ts), stessa fonte usata
 *   da cdp_fe_commons. La stessa variabile `VUE_APP_FE_COMMONS_DEBUG` controlla
 *   sia la libreria che questo logger.
 * - `log()` / `warn()` / `error()`: SEMPRE emessi, anche in produzione.
 *   ⚠️ Non passare mai PII o payload utente a questi metodi.
 *
 * In ambienti senza `window` (Jest): fallback su `NODE_ENV !== 'production'`.
 */
function isDebugEnabled(): boolean {
    if (typeof window !== 'undefined') {
        const cfg = window.FE_COMMONS_CONFIG;
        if (cfg && typeof cfg.debug === 'boolean') {
            return cfg.debug;
        }
    }
    return process.env.NODE_ENV !== 'production';
}

export const logger = {
    debug(...args: unknown[]): void {
        if (isDebugEnabled()) {
            console.debug(...args);
        }
    },
    log(...args: unknown[]): void {
        console.log(...args);
    },
    warn(...args: unknown[]): void {
        console.warn(...args);
    },
    error(...args: unknown[]): void {
        console.error(...args);
    },
};
